import { createFileRoute } from "@tanstack/react-router";
import Join from "@/pages/Join";

export const Route = createFileRoute("/_app/join")({
  component: () => (
    <Join />
  ),
});
